/* eslint-disable max-len */
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../../styles/styles.scss";

const TermsPage = () => (
  <div className="blurred-background legal-page legal-page--terms">
    <Helmet>
      <title>Extra English - regulamin</title>
    </Helmet>
    <div className="legal-page__container">
      <header className="legal-page__header">
        <span className="legal-page__eyebrow">Extra English</span>
        <h1>Regulamin świadczenia usług Extra English</h1>
        <p>
          Zasady zapisów, organizacji zajęć, płatności, reklamacji, rezygnacji i zwrotów.
        </p>
      </header>

      <div className="legal-page__summary">
        <div>
          <span>Usługodawca</span>
          <strong>Alicja Marciniak</strong>
        </div>
        <div>
          <span>Kontakt</span>
          <strong>szkola@extra-english.pl</strong>
        </div>
        <div>
          <span>Aktualizacja</span>
          <strong>3 czerwca 2026 r.</strong>
        </div>
      </div>

      <article className="legal-document terms-page">
          <p>
            Niniejszy regulamin określa zasady korzystania z usług edukacyjnych świadczonych przez Extra English, w tym zasady zapisów, płatności,
            organizacji zajęć, reklamacji, rezygnacji oraz zwrotów. Regulamin stanowi wzorzec umowy w rozumieniu przepisów prawa cywilnego.
          </p>

          <h2>1. Usługodawca i dane kontaktowe</h2>
          <ol>
            <li>Usługodawcą jest Alicja Marciniak, prowadząca działalność pod marką Extra English.</li>
            <li>Adres: ul. Wypoczynkowa 43, 62-081 Baranowo.</li>
            <li>NIP: 777-255-43-86, REGON: 300953920.</li>
            <li>Adres e-mail: szkola@extra-english.pl.</li>
            <li>Telefon: +48 575 400 141.</li>
            <li>Strona internetowa: www.extra-english.pl.</li>
          </ol>

          <h2>2. Definicje</h2>
          <ol>
            <li>Szkoła - Extra English, czyli Usługodawca świadczący usługi nauki języka angielskiego.</li>
            <li>Klient - osoba zawierająca umowę ze Szkołą, w szczególności rodzic lub opiekun prawny ucznia, albo pełnoletni uczestnik zajęć.</li>
            <li>Uczeń - osoba uczestnicząca w zajęciach językowych.</li>
            <li>Zajęcia - lekcje języka angielskiego prowadzone stacjonarnie lub online, indywidualnie, dwuosobowo albo grupowo.</li>
            <li>Umowa - umowa o świadczenie usług edukacyjnych zawierana pomiędzy Klientem a Szkołą.</li>
            <li>Serwis - strona internetowa dostępna pod adresem www.extra-english.pl.</li>
          </ol>

          <h2>3. Zakres usług</h2>
          <ol>
            <li>Szkoła świadczy usługi nauki języka angielskiego dla dzieci, młodzieży i dorosłych.</li>
            <li>Oferta obejmuje w szczególności zajęcia indywidualne, zajęcia dwuosobowe, zajęcia grupowe, zajęcia online, kursy egzaminacyjne, zajęcia tematyczne oraz inne usługi edukacyjne wskazane w ofercie Szkoły.</li>
            <li>Aktualny opis usług, orientacyjny cennik oraz informacje organizacyjne są dostępne w Serwisie lub przekazywane Klientowi przed zawarciem Umowy.</li>
            <li>Zajęcia prowadzone są zgodnie z harmonogramem ustalonym ze Szkołą. Szkoła może dopasować grupę do wieku, poziomu językowego, dostępności terminów oraz celów edukacyjnych Ucznia.</li>
          </ol>

          <h2>4. Zapisy i zawarcie umowy</h2>
          <ol>
            <li>Zapisu można dokonać przez formularz w Serwisie, telefonicznie, mailowo lub bezpośrednio w kontakcie ze Szkołą.</li>
            <li>Wysłanie formularza zapisu jest prośbą o kontakt i nie gwarantuje miejsca w grupie ani zawarcia Umowy.</li>
            <li>Umowa zostaje zawarta po potwierdzeniu przez Szkołę dostępności miejsca, uzgodnieniu rodzaju zajęć, harmonogramu i warunków płatności oraz zaakceptowaniu przez Klienta warunków świadczenia usług.</li>
            <li>W przypadku Ucznia niepełnoletniego Umowę zawiera rodzic albo opiekun prawny.</li>
            <li>Klient jest zobowiązany podać prawdziwe i aktualne dane potrzebne do kontaktu, organizacji zajęć i rozliczeń.</li>
          </ol>

          <h2>5. Organizacja zajęć</h2>
          <ol>
            <li>Zajęcia odbywają się w terminach ustalonych ze Szkołą, zgodnie z harmonogramem roku szkolnego lub indywidualnymi ustaleniami.</li>
            <li>Szkoła może odwołać lub przełożyć zajęcia z ważnych przyczyn organizacyjnych, technicznych, zdrowotnych albo losowych. W takim przypadku Szkoła ustala nowy termin lub rozlicza zajęcia zgodnie z Umową.</li>
            <li>W przypadku zajęć online Klient zapewnia Uczniowi urządzenie z dostępem do internetu, kamerą, mikrofonem oraz aktualnym oprogramowaniem wymaganym do udziału w lekcji.</li>
            <li>Zasady odrabiania nieobecności, zgłaszania odwołań i rozliczania zajęć mogą zależeć od rodzaju kursu i są przekazywane Klientowi przed zawarciem Umowy lub w jej treści.</li>
            <li>Materiały edukacyjne, książki lub dostęp do platform zewnętrznych mogą być rozliczane osobno, jeżeli tak wynika z oferty lub Umowy.</li>
          </ol>

          <h2>6. Ceny i płatności</h2>
          <ol>
            <li>Ceny usług są podawane w złotych polskich. Informacje o cenach znajdują się w ofercie, cenniku, Umowie lub indywidualnym potwierdzeniu warunków.</li>
            <li>Płatność może być realizowana przelewem bankowym, gotówką, płatnością online lub inną metodą udostępnioną przez Szkołę.</li>
            <li>Numer rachunku bankowego Szkoły: 36 1140 2004 0000 3502 8025 8272.</li>
            <li>W tytule przelewu należy podać imię i nazwisko Ucznia, nazwę grupy lub rodzaj zajęć oraz okres, którego dotyczy płatność.</li>
            <li>Jeżeli Szkoła udostępnia płatności online, Podmiotem świadczącym obsługę płatności online jest Autopay S.A.</li>
            <li>Dostępne metody płatności online mogą obejmować szybki przelew, BLIK, płatność kartą oraz inne metody udostępnione przez operatora płatności w momencie składania dyspozycji płatności.</li>
            <li>Dla płatności kartą obsługiwane są karty: Visa, Visa Electron, Mastercard, Mastercard Electronic oraz Maestro.</li>
            <li>Czas realizacji zamówienia jest liczony od momentu uzyskania pozytywnej autoryzacji płatności, chyba że Umowa lub indywidualne ustalenia stanowią inaczej.</li>
            <li>Szkoła nie przechowuje danych kart płatniczych Klientów. Dane kart są przetwarzane przez operatora płatności zgodnie z zasadami bezpieczeństwa właściwymi dla danej metody płatności.</li>
          </ol>

          <h2>7. Rezygnacja, rozwiązanie umowy i zwroty</h2>
          <ol>
            <li>Klient może zrezygnować z usług na zasadach określonych w Umowie lub indywidualnych ustaleniach ze Szkołą.</li>
            <li>Jeżeli Umowa przewiduje okres wypowiedzenia, opłaty za zajęcia należne w okresie wypowiedzenia pozostają wymagalne.</li>
            <li>Zwrot nadpłaty następuje na rachunek bankowy Klienta albo tą samą metodą, którą dokonano płatności, o ile jest to technicznie możliwe.</li>
            <li>W przypadku zwrotu za transakcję opłaconą kartą płatniczą zwrot środków zostanie dokonany na rachunek karty użytej do płatności.</li>
            <li>Zwrot następuje w terminie do 14 dni od dnia uzgodnienia kwoty zwrotu lub uznania reklamacji, chyba że przepisy prawa wymagają krótszego terminu.</li>
          </ol>

          <h2>8. Odstąpienie od umowy zawartej na odległość</h2>
          <ol>
            <li>Konsument, który zawarł Umowę na odległość, może odstąpić od niej w terminie 14 dni bez podawania przyczyny, o ile przepisy prawa nie przewidują wyjątku.</li>
            <li>Oświadczenie o odstąpieniu można przesłać na adres e-mail: szkola@extra-english.pl.</li>
            <li>Jeżeli Klient zażąda rozpoczęcia świadczenia usług przed upływem terminu odstąpienia, Szkoła może naliczyć opłatę za świadczenia spełnione do chwili odstąpienia, zgodnie z przepisami prawa.</li>
            <li>Prawo odstąpienia może nie przysługiwać w przypadkach wskazanych w ustawie o prawach konsumenta, w szczególności gdy usługa została w pełni wykonana za wyraźną zgodą Klienta przed upływem terminu odstąpienia.</li>
          </ol>

          <h2>9. Reklamacje</h2>
          <ol>
            <li>Klient może złożyć reklamację dotyczącą usług, płatności lub działania Serwisu.</li>
            <li>Reklamację należy przesłać na adres e-mail szkola@extra-english.pl albo złożyć pisemnie na adres Szkoły.</li>
            <li>Reklamacja powinna zawierać dane Klienta, opis sprawy, datę zdarzenia oraz oczekiwany sposób rozwiązania.</li>
            <li>Szkoła rozpatruje reklamację w terminie 14 dni od dnia jej otrzymania. Jeżeli sprawa wymaga uzupełnienia informacji, termin biegnie od dnia otrzymania potrzebnych danych.</li>
          </ol>

          <h2>10. Dane osobowe i prywatność</h2>
          <ol>
            <li>Administratorem danych osobowych jest Alicja Marciniak, prowadząca działalność pod marką Extra English.</li>
            <li>Dane osobowe są przetwarzane w celu obsługi zapisu, zawarcia i wykonania Umowy, kontaktu z Klientem, organizacji zajęć, rozliczeń oraz realizacji obowiązków prawnych.</li>
            <li>Szczegółowe informacje o przetwarzaniu danych osobowych i plikach cookies znajdują się w polityce prywatności dostępnej w Serwisie.</li>
          </ol>

          <h2>11. Postanowienia końcowe</h2>
          <ol>
            <li>Regulamin jest dostępny nieodpłatnie w Serwisie w sposób umożliwiający jego pozyskanie, odtwarzanie i utrwalanie.</li>
            <li>Szkoła może zmienić Regulamin z ważnych przyczyn, w szczególności z powodu zmian prawa, zmian organizacyjnych, zmian metod płatności lub zmian zakresu świadczonych usług.</li>
            <li>Zmiany Regulaminu nie naruszają praw nabytych Klientów wynikających z zawartych wcześniej Umów.</li>
            <li>W sprawach nieuregulowanych Regulaminem stosuje się przepisy prawa polskiego.</li>
          </ol>

          <p className="mt-4">
            Informacje o danych do płatności i dostępnych metodach płatności znajdują się na stronie{" "}
            <Link to="/payment">Szczegóły płatności</Link>.
          </p>
          <p>
            Ostatnia aktualizacja regulaminu: 3 czerwca 2026 r.
          </p>
      </article>
    </div>
  </div>
);

export default TermsPage;
